export default __webpack_public_path__ + "static/media/competition.5efc6903.svg";